import React, { useEffect, useRef, useState } from "react";
import { Form, Toast, ToastContainer, Button, NavLink } from "react-bootstrap";
import { BiErrorCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { axiosOpen } from "../../api/axios";
import logo from "../../assests/images/product-logo.png";
import { BiArrowBack } from "react-icons/bi";
import { Link } from "react-router-dom";
import {  Modal } from 'antd';
import AddCompany from "../Company/Add/AddCompany";
import { toast, Toaster } from "react-hot-toast";

const LOGIN_URL = "auth/login";

const LoginForm = () => {
  const navigate = useNavigate();
  const emailRef = useRef();
  const passwordRef = useRef();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showToster, setShowToster] = useState(false);
  const [userToken, setUserToken] = useState(null);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const showModal = () => {
    setOpen(true);
  };
  
  const handleOk = (data) => {
        
      setOpen(false);
      toast.success(data)   
    
  };
  
  const handleCancel = () => {
    setOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    (async () => {
      try {
        const response = await axiosOpen.post("api/user/login", { email, password });
        debugger
        localStorage.userID = response?.data?.userid;
        localStorage.userToken = response?.data?.token;
        localStorage.userEmail = response?.data?.user_email;
        localStorage.compId = response?.data?.compId;
        localStorage.userID = response?.data?.userid;
        localStorage.role = response?.data?.role;
        debugger
        const compData = await axiosOpen.get("/api/company/getdata/"+localStorage.getItem('userID'));
        compData.data.data != null ? response?.data?.role === "superadmin"?navigate("/superadmin/users"): navigate("/proposalform") : navigate("/list/company");
        // navigate("/");
      } catch (err) {
        if (err.response.status === 401) {
          setShowToster(true);
        }
      }
    })();
  };

  const handleForgotPassword = (e) => {
   e.preventDefault();
    // if (email !== "") {
    //   navigate("/reset-password/c1-23");
    // }
    
    const response = axiosOpen.post("api/user/forgotpassword", { email });
    toast.success("Password reset link has been sent to your email address");
  };

  const handleForgotPasswordSwitch = () => {
    setForgotPassword((currentValue) => !currentValue);
    setEmail("");
    setPassword("");
  };

  return (
    <>
    <Toaster />
    <div className="position-relative login-page">
      {showToster && (
        <ToastContainer position="top-end" className="width-toast">
          <Toast
            onClose={() => setShowToster(false)}
            show={showToster}
            delay={3000}
            min-width="50px"
            autohide
          >
            <Toast.Header className="toaster-header">
              <BiErrorCircle className="toaster-icon" />
              <div className="toaster-body">
                <strong className="me-auto">Oops!</strong>
                <br />

                <strong className="me-auto">Invalid Credential</strong>
              </div>
            </Toast.Header>
          </Toast>
        </ToastContainer>
      )}

      <div className="left-section"></div>
      <div className="right-section">
        {forgotPassword && (
          <div className="form-signin">
            <div className="d-flex w-100">
              <BiArrowBack
                style={{
                  fontSize: "35px",
                  color: "#FFFFFF",
                  cursor: "pointer",
                }}
                onClick={handleForgotPasswordSwitch}
              />
              <img
                alt="brand logo"
                src={logo}
                width="250"
                height="auto"
                className="mx-auto"
              />
            </div>
            <h1>Forgot Password</h1>
            <Form className="form" onSubmit={handleForgotPassword}>
              <Form.Floating className="mb-2 ">
                <Form.Control
                  className="mb-3"
                  id="floatingInputCustom"
                  type="email"
                  placeholder="name@example.com"
                  ref={emailRef}
                  autoComplete="off"
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  value={email}
                  required
                />
                <label htmlFor="floatingInputCustom">Email Address</label>
              </Form.Floating>
              <Button
                variant="primary"
                className="login-btn mx-auto w-100"
                type="submit"
              > 
                Forgot Password
              </Button>
            </Form>
          </div>
        )}

        {!forgotPassword && (
          <div className="form-signin">
            <div>
              <img alt="brand logo" src={logo} width="250" height="auto" />
            </div>
            <h1>LOGIN</h1>
            <Form className="form" onSubmit={handleSubmit}>
              <Form.Floating className="mb-3 ">
                <Form.Control
                  id="floatingInputCustom"
                  type="email"
                  placeholder="name@example.com"
                  ref={emailRef}
                  autoComplete="off"
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  value={email}
                  required
                />
                <label htmlFor="floatingInputCustom">Email Address</label>
              </Form.Floating>
              <Form.Floating>
                <Form.Control
                  id="floatingPasswordCustom"
                  type="password"
                  placeholder="Password"
                  ref={passwordRef}
                  autoComplete="off"
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  value={password}
                  required
                />
                <label htmlFor="floatingPasswordCustom">Password</label>
              </Form.Floating>
              <Form.Group
                controlId="formBasicCheckbox"
                className="w-100 d-flex justify-content-between align-items-center mt-4"
              >
                <Button variant="primary" className="login-btn" type="submit">
                  Login
                </Button>
                <Button
                  variant="link"
                  className="text-decoration-none text-white"
                  onClick={handleForgotPasswordSwitch}
                >
                  Forgot Password ?
                </Button>
                 
              </Form.Group>
            </Form>
            <div>
              <Modal  open={open}
              footer={null}
              onCancel={handleCancel}>
                <AddCompany  handleOk = {handleOk}/>
              </Modal>       
              <Link  className="text-decoration-none text-white" onClick={showModal}>
                      <span className="company" ><u>Register your Company</u></span>
              </Link>
            </div>
            <div className="copyright">
            Powered by SJinnovation LLC
            </div>
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default LoginForm;
